module.exports = __webpack_public_path__ + "static/desktop/img/case2.a59813ed.jpg";